import { SchemaType } from '$shared/constants/SchemaType';
import { schemaData } from '$shared/lib/data/SchemaData';
import { DatasetMatchRecord } from '$shared/models/dataset/DatasetMatchRecord';
import { DeaDatasetMatchRecord } from '$shared/models/dataset/dea/DeaDatasetMatchRecord';
import { NpiDatasetMatchRecord } from '$shared/models/dataset/npi/NpiDatasetMatchRecord';

export class DatasetMatchRecordFactory {
  static readonly matchModels: Map<string, new (args: ObjectType<any>) => DatasetMatchRecord> =
    new Map();

  static set(key: string, model: new (args: ObjectType<any>) => DatasetMatchRecord): void {
    this.matchModels.set(key, model);
  }

  static get(type: string, response: ObjectType<any>): any {
    const MatchRecordModel = this.matchModels.get(type);
    if (MatchRecordModel) return new MatchRecordModel(response);

    const datasetType = schemaData.getSchema(SchemaType.DatasetType);
    if (type === datasetType.Npi) {
      return new NpiDatasetMatchRecord(response);
    }
    if (type === datasetType.Dea) {
      return new DeaDatasetMatchRecord(response);
    }
    return new DatasetMatchRecord(response);
  }
}
